/** Sort web live chat messages oldest → newest (ULID / created_at). */
export function sortWebChatMessages<T extends { message_id?: string; created_at?: string }>(
  items: T[]
): T[] {
  return [...items].sort((a, b) => {
    const idA = String(a?.message_id || '');
    const idB = String(b?.message_id || '');
    if (idA && idB) return idA.localeCompare(idB);
    const tA = Date.parse(a?.created_at || '') || 0;
    const tB = Date.parse(b?.created_at || '') || 0;
    return tA - tB;
  });
}
